import { Code } from 'lucide-react';
import { EmailTemplateList } from '@/types/template';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface EmailTemplateSourceDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  template: EmailTemplateList | null;
}

export function EmailTemplateSourceDialog({
  open,
  onOpenChange,
  template,
}: EmailTemplateSourceDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Code className="h-5 w-5" />
            Source: {template?.name}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <div className="text-xs font-medium text-muted-foreground mb-1">
              Subject Template
            </div>
            <pre className="bg-muted rounded-md p-3 text-sm font-mono overflow-x-auto whitespace-pre-wrap leading-relaxed border">
              {template?.subject_template || 'No subject template'}
            </pre>
          </div>
          <div>
            <div className="text-xs font-medium text-muted-foreground mb-1">
              HTML Template
            </div>
            <pre className="bg-muted rounded-md p-4 text-sm font-mono overflow-x-auto whitespace-pre-wrap leading-relaxed border max-h-[40vh] overflow-y-auto">
              {template?.html_template || 'No HTML template'}
            </pre>
          </div>
          {template?.text_template && (
            <div>
              <div className="text-xs font-medium text-muted-foreground mb-1">
                Text Template
              </div>
              <pre className="bg-muted rounded-md p-4 text-sm font-mono overflow-x-auto whitespace-pre-wrap leading-relaxed border max-h-[30vh] overflow-y-auto">
                {template.text_template}
              </pre>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
